class AllocateSubCaseModalController {
  /* @ngInject */
  constructor(
    $uibModalInstance, $http, $state,
    CASE_CHECK_STATUS, check, caseId, caseCheck
  ) {
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$state = $state;
    this.CASE_CHECK_STATUS = CASE_CHECK_STATUS;
    this.check = check;
    this.caseId = caseId;
    this.caseCheck = caseCheck;
  }

  $onInit() {
    this.data = {
      status: this.caseCheck ? this.caseCheck.status : 'Positive',
      check: this.check.key,
      comment: this.caseCheck ? this.caseCheck.comment : '',
    };
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    this.submitting = true;

    this.$http.put(`/case/${this.caseId}/caseCheck`, this.data)
      .then(() => {
        this.reload();
      })
      .catch(() => (this.submitting = false));
  }

  reload() {
    this.submitting = false;
    this.$uibModalInstance.close();
    this.$state.reload();
  }
}

export default AllocateSubCaseModalController;



// WEBPACK FOOTER //
// ./client/components/case-check-modal/case-check-modal.js